import { type ThemeOptions } from '@mui/material';

export function createAutocompleteStyles() {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        paper: ({ theme }) => ({
          variants: [
            {
              props: (props) => !props['square'],
              style: {
                borderRadius: `${theme.shape.borderRadiusMd}px`,
              },
            },
          ],
        }),
      },
    },
  } as ThemeOptions['components'];
}
